import { useState } from "react";

import { EditIcon, MoreIcon, TrashIcon } from "@/assets/icons";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@/components/ui/popover";

import { PopoverPortal } from "@radix-ui/react-popover";

export default function WidgetConfigurationPopover({
  onOpenWidgetConfig,
  onRemoveWidget,
  isRemovePending = false
}: Readonly<{
  onOpenWidgetConfig: () => void;
  onRemoveWidget: () => void;
  isRemovePending?: boolean;
}>) {
  const [openConfigWidget, setOpenConfigWidget] = useState(false);

  return (
    <Popover onOpenChange={setOpenConfigWidget} open={openConfigWidget}>
      <PopoverTrigger asChild>
        <button type="button" aria-label="More options">
          <MoreIcon className="h-8 w-8 fill-txtBody" />
        </button>
      </PopoverTrigger>
      <PopoverPortal>
        <PopoverContent
          className="rounded-xl w-[152px] z-[999] bg-white p-0"
          side="bottom"
          align="end"
          hideWhenDetached
        >
          <div className="flex flex-col">
            <button
              type="button"
              className="flex items-center justify-start gap-2 text-xs text-txtHeading p-2 hover:bg-white-smoke rounded-t-xl"
              onClick={() => {
                onOpenWidgetConfig();
                setOpenConfigWidget(false);
              }}
            >
              <EditIcon className="h-5 w-5 fill-txtBody" />
              Edit
            </button>
            <button
              type="button"
              className="flex items-center justify-start gap-2 text-xs text-txtHeading p-2 hover:bg-white-smoke rounded-b-xl disabled:opacity-50 disabled:cursor-not-allowed"
              onClick={onRemoveWidget}
              disabled={isRemovePending}
            >
              <TrashIcon className="h-5 w-5 fill-txtBody" />
              Remove
            </button>
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Popover>
  );
}
